module.exports = __webpack_public_path__ + "static/media/qr-codes-desktop-bottom.8b2fb037.png";